/* HEFT Home USA: standard Ads measurement only; no customer field values. */
(function () {
  'use strict';
  if (!window.Shopify || window.Shopify.shop !== 'heft-home.myshopify.com' ||
      window.Shopify.designMode || !/^(www\.)?hefthome\.com$/.test(location.hostname)) return;
  var destination = 'AW-18430827195';
  var pendingKey = 'heft_usa_inquiry_pending_v1';
  var configured = false;
  var sent = false;
  function privacyAllows() {
    var privacy = window.Shopify.customerPrivacy;
    return !!(privacy && privacy.marketingAllowed() &&
      privacy.analyticsProcessingAllowed() && privacy.saleOfDataAllowed());
  }
  function configure() {
    if (configured || !privacyAllows()) return;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    // Destination-specific options avoid enabling customer matching or audiences.
    window.gtag('config', destination, {
      send_page_view: false,
      allow_ad_personalization_signals: false,
      allow_enhanced_conversions: false
    });
    if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
      window.gtag('js', new Date());
      var script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + destination;
      document.head.appendChild(script);
    }
    configured = true;
  }
  function measureConfirmedInquiry() {
    if (sent || !privacyAllows() || !document.querySelector('[data-heft-usa-inquiry-success]')) return;
    var pending;
    try { pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null'); } catch (_) { return; }
    if (!pending || !pending.id || Date.now() - pending.at > 3600000) return;
    configure();
    sent = true;
    window.gtag('event', 'conversion', {
      send_to: destination + '/vxQOCO3rxfEcELu1wNRE',
      transaction_id: pending.id,
      value: 0,
      currency: 'USD',
      event_callback: function () {
        try { sessionStorage.removeItem(pendingKey); } catch (_) {}
      }
    });
  }
  function ready() {
    var form = document.getElementById('contact_form');
    if (form) form.addEventListener('submit', function () {
      if (!privacyAllows() || !form.checkValidity()) return;
      var id = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() :
        'inquiry-' + Date.now() + '-' + Math.random().toString(36).slice(2);
      try { sessionStorage.setItem(pendingKey, JSON.stringify({id: id, at: Date.now()})); } catch (_) {}
    });
    configure();
    measureConfirmedInquiry();
  }
  document.addEventListener('visitorConsentCollected', function () {
    configure();
    measureConfirmedInquiry();
  });
  function boot() {
    if (window.Shopify.customerPrivacy) ready();
    else if (window.Shopify.loadFeatures) window.Shopify.loadFeatures([
      {name: 'consent-tracking-api', version: '0.1'}
    ], function (error) { if (!error) ready(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
